





































import { IOvertimeRequest, OvertimeRequestStateEnum } from '@/models';

import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    request: {
      type: Object as PropType<IOvertimeRequest>
    },
    canRejectOrApproveState: Boolean,
    canCancel: Boolean
  },

  data() {
    return {
      OvertimeRequestStateEnum
    };
  },

  computed: {
    buttonPositionStyle(): string {
      return this.canRejectOrApproveState && this.canCancel
        ? 'justify-space-between'
        : 'justify-end';
    },

    cancelButtonStyle() {
      return this.canRejectOrApproveState ? 'cancel-request' : 'white--text';
    },

    cancelText(): string {
      return this.request.state == OvertimeRequestStateEnum.Approved
        ? 'Cancel Approved Request'
        : 'Cancel';
    }
  },

  methods: {
    openCommentDialog(state: OvertimeRequestStateEnum) {
      this.$emit('openCommentDialog', state);
    }
  }
});
